/** Floors a numeric <input>'s parsed value at `min`, so typing e.g. "-5" into a field that must
 *  stay non-negative (roof area, consumption, prices, counts…) can't produce a negative number in
 *  state - the HTML `min` attribute alone only affects native validity styling, not onChange. */
export function clampMin(value: number, min = 0): number {
  return value < min ? min : value
}

/** Like clampMin, but also caps at `max` - for fields where an unrealistically large typo
 *  (roof area, e.g. an extra digit) should be rejected client-side too, not just negative input. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}

/** Parses a price typed with either German (comma) or English (dot) decimal notation into a
 *  number, e.g. "12500,50" or "12.500,50" or "12500.50" all yield 12500.5. Handwerker on German
 *  keyboards/locales naturally type a comma as decimal separator; a plain `Number()` call (or a
 *  native `<input type="number">`, which rejects the comma outright in many browsers) turned that
 *  into a silent "ungültiger Preis" error even though the entered price was perfectly valid. */
export function parsePriceInput(raw: string): number {
  const trimmed = raw.trim()
  if (!trimmed) return NaN
  const hasComma = trimmed.includes(',')
  const hasDot = trimmed.includes('.')
  let normalized = trimmed
  if (hasComma && hasDot) {
    normalized = trimmed.lastIndexOf(',') > trimmed.lastIndexOf('.') ? trimmed.replaceAll('.', '').replace(',', '.') : trimmed.replaceAll(',', '')
  } else if (hasComma) {
    normalized = trimmed.replace(',', '.')
  }
  return Number(normalized)
}
